import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import { LottiePlayer } from '@repo/ui';
import { Button, Description, TopNavigation } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

export const PersonalDeductionCollectCompletedContainer = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { openChannelTalk } = useChannelTalk();
  const router = useRouter();

  return (
    <>
      <TopNavigation.Basic
        className={'max-w-[1080px] mx-auto'}
        rightTextButton={{
          state: 'gray',
          label: '문의하기',
          onClick: () => {
            sendClickEvent('personal-deduction-complete_topnav_cx');

            openChannelTalk(SUPPORT_BOT_LINK.home);
          }
        }}
      />
      <main className={'w-full flex flex-1 items-center justify-center max-w-screen-basicMax mx-auto'}>
        <div className={'-mt-[92px]'}>
          <Description.Guide
            titleSize={'large'}
            subTitle={'필요한 자료를 모두 수집하여,\n이제 인적공제도 받을 수 있어요!'}
            description={'인적공제를 포함해 제휴 세무사가 빠르게 검토할게요. 진행과정은 카카오톡 알림톡으로 안내해드릴게요.'}
            imgChild={<LottiePlayer src={'/lotties/ani_check.json'} loop={false} className={'w-20 h-20'} />}
          />
        </div>
        <Button.StickyBottom.Wrapper className={'px-4.5'}>
          <Button.StickyBottom.Button
            state={'primary'}
            onClick={() => {
              sendClickEvent('personal-deduction-complete_home');

              router.push(COMMON_PATHS.환급조회목록);
            }}
          >
            환급 홈으로 가기
          </Button.StickyBottom.Button>
        </Button.StickyBottom.Wrapper>
      </main>
    </>
  );
};
